import { RequestService } from './request.service';
import { Observable } from 'rxjs/';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';

@Injectable()
export class PermissionsService {

    constructor(private configService: ConfigService, private requestService: RequestService) { }

    gmailSmtpPermissions(): Observable<any> {

        return Observable.defer(() => this.openPermissionsWindow());
    }

    private openPermissionsWindow(): Observable<any> {
        let urlBuilder: Array<string> = [];
        urlBuilder.push(
            'response_type=code',
            'client_id=' + this.configService.get('google').clientId,
            'redirect_uri=' + window.location.origin + this.configService.get('google').callbackRoute,
            'access_type=offline',
            'prompt=consent',
            'scope=https://www.googleapis.com/auth/userinfo.email https://mail.google.com/'
        );

        let url = this.configService.get('google').url + urlBuilder.join('&');
        let options = 'width=500, height=500, left=' +
            (window.outerWidth - 500) / 2 + ', top=' +
            (window.outerHeight - 500) / 2.5;

        let popup = window.open(url, '', options);
        window.focus();

        return Observable.fromEvent(window, 'message')
            .take(1)
            .filter((e: any) => e.origin == window.location.origin)
            .map(e => {
                let url = new URL(e.source.location.href);
                let params = new URLSearchParams(url.search);
                return {
                    code: params.get('code')
                }
            })
            .do(_ => popup.close());
    }

    getEmployeeData(userId: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.getByEmail.api + '?' + 'emailId=' + userId;
        return this.requestService.getDelegate(url);
    }

    // Requires client secret -> put on backend
    // private getAccessToken(code: string): Observable<any> {
    //     console.log(code)
    //     let data = {
    //         code: code,
    //         client_id: this.configService.get('google').clientId,
    //         redirect_uri: window.location.origin + this.configService.get('google').callbackRoute,
    //         scope: 'https://www.googleapis.com/auth/gmail.send',
    //         grant_type: 'authorization_code',
    //         access_type: 'offline'
    //     };
        
    //     return this.requestService.post(this.configService.get('google').authCodeUrl, data)
    // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/permissions.service.ts